<div class="supplier-orders-details-container">
  <p-table [value]="ordersDetailsList" [responsive]="true" [responsiveLayout]="'stack'"
           [scrollable]="false" [breakpoint]="'550px'" rowGroupMode="subheader"
           groupRowsBy="invoiceId">
    <ng-template pTemplate="header">
      <tr>
        <th>{{'SUPPLIERS.PRODUCT' | translate}}</th>
        <th>{{'SUPPLIERS.PURCHASE' | translate}}</th>
        <th>{{'SUPPLIERS.PRICE' | translate}}</th>
        <th>{{'SUPPLIERS.DATE' | translate}}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="groupheader" let-product>
      <tr pRowGroupHeader style="background: #D9D9D9">
        <td colspan="4">
          <span class="p-text-bold p-ml-2">{{'SUPPLIERS.INVOICE_ID' | translate}}: {{product.invoiceId}}</span>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
      <tr>
        <td>
          <b class="p-column-title">{{'SUPPLIERS.PRODUCT' | translate}}</b>
          {{product.supplyName}}</td>
        <td>
          <b class="p-column-title">{{'SUPPLIERS.PURCHASE' | translate}}</b>
          {{product.quantity}}{{product.unitOfMeasurementShortName}}</td>
        <td>
          <b class="p-column-title">{{'SUPPLIERS.PRICE' | translate}}</b>
          {{product.grossPrice}} {{currency}}</td>
        <td>
          <b class="p-column-title">{{'SUPPLIERS.DATE' | translate}}</b>
          {{product.date}}</td>
      </tr>
    </ng-template>
  </p-table>
</div>

